import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en";
import es from "./locales/es";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    // First visit must come up in the browser's language. Phones report
    // region codes ("es-MX", "es-419"), so collapse every detected variant
    // to its base code and reject anything we don't ship (-> fallbackLng).
    // This keeps i18n.language an exact "en"/"es" for the EN/ES toggles.
    supportedLngs: ["en", "es"],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "adam_lang",
      convertDetectedLanguage: (lng) => lng.split("-")[0],
    },
  });

export default i18n;
